// src/utils/googleAnalytics.ts
import ReactGA from 'react-ga4';
import Cookies from 'js-cookie';

export const GA_MEASUREMENT_ID = 'G-X1HX25HCGP';

export const initGA = () => {
  const consent = Cookies.get('user-consent');
  if (GA_MEASUREMENT_ID && consent === 'true') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }
};

export const logPageView = (path: string) => {
  const consent = Cookies.get('user-consent');
  if (GA_MEASUREMENT_ID && consent === 'true') {
    ReactGA.send({ hitType: 'pageview', page: path, title: document.title });
  }
};

export const logEvent = (category: string, action: string, label?: string, value?: number) => {
  const consent = Cookies.get('user-consent');
  if (GA_MEASUREMENT_ID && consent === 'true') {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
      value: value,
    });
  }
};